import { createFileRoute } from '@tanstack/react-router'
import { FacilitiesSettings } from '@/features/organizations/settings/facilities'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/facilities'
)({
  component: FacilitiesSettings,
})
